// Скелетон: shadcn 4.21.1 (base-mira), подогнан под ui-spec (задача D5): плашка --muted той же сетки, что данные;
// мерцает (прозрачность) только без запроса уменьшенного движения — `motion-safe:`.
import { cn } from 'cn';
import type * as React from 'react';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('rounded-md bg-muted motion-safe:animate-pulse', className)} {...props} />;
}

export { Skeleton };
